module.exports = __webpack_public_path__ + "static/media/logoEthics.7d179a93.png";